function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#666",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M134 122.04H82"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h192v192H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#e60000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M150 142h8M46.04 142h8"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 134,
  y: 86,
  width: 40,
  height: 72,
  rx: 6,
  ry: 6,
  fill: "none",
  stroke: "#666",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 18,
  y: 62,
  width: 64.08,
  height: 96,
  rx: 6,
  ry: 6,
  fill: "none",
  stroke: "#666",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#666",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M115.83 142H82M96 124.19l.02 15.81M166 86V40a14 14 0 00-14-14H40a14 14 0 00-14 14v22"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 108,
  r: 4,
  fill: "#e60000"
});

var SvgConnectedDevicesMid = function SvgConnectedDevicesMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

export default SvgConnectedDevicesMid;